import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { IsNullOrEmpty } from "../../helpers/utility";
import { changePasswordRequest } from "../../store/user/user.actions";

const Password = () => {
    const dispatch = useDispatch();
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [oVisible, setOVisible] = useState(false);
    const [nVisible, setNVisible] = useState(false);
    const [cVisible, setCVisible] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);

    const validate = () => {
        return (
            !IsNullOrEmpty(oldPassword) &&
            !IsNullOrEmpty(newPassword) &&
            !IsNullOrEmpty(confirmPassword) &&
            newPassword === confirmPassword
        );
    };
    const handleSave = () => {
        if (validate()) {
            dispatch(
                changePasswordRequest({
                    oldPassword: oldPassword,
                    newPassword: newPassword,
                })
            );
        } else {
            setFormSubmitted(true);
        }
    };

    return (
        <div>
            <div className="mb-6">
                <h3>Change Password</h3>
            </div>

            <div className="w-full md:max-w-[288px]">
                <div className="py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm mb-[7px] relative">
                    <div className="flex flex-col">
                        <label
                            htmlFor="oldPassword"
                            className="text-black-50 capitalize mb-px"
                        >
                            Old password
                        </label>
                        <input
                            type={oVisible ? "text" : "password"}
                            className="text-black-60 outline-none"
                            id="oldPassword"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                        />
                    </div>
                    <div
                        onClick={() => setOVisible(!oVisible)}
                        className="absolute top-2/4 -translate-y-2/4 right-2.5 cursor-pointer"
                    >
                        {oVisible ? (
                            <span>
                                <svg
                                    width="22"
                                    height="16"
                                    className="stroke-current text-black-50"
                                    viewBox="0 0 22 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M13.9988 8.01367C13.9988 9.67053 12.6556 11.0137 10.9988 11.0137C9.34193 11.0137 7.99878 9.67053 7.99878 8.01367C7.99878 6.35682 9.34193 5.01367 10.9988 5.01367C12.6556 5.01367 13.9988 6.35682 13.9988 8.01367Z"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M1.45703 8.01364C2.73131 3.95655 6.52159 1.01367 10.9992 1.01367C15.4769 1.01367 19.2672 3.95659 20.5414 8.01371C19.2672 12.0708 15.4769 15.0137 10.9992 15.0137C6.52159 15.0137 2.73128 12.0708 1.45703 8.01364Z"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                        ) : (
                            <span>
                                <svg
                                    width="22"
                                    height="20"
                                    className="stroke-current text-black-50"
                                    viewBox="0 0 22 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1.99878 1.01367L5.58794 4.60283M19.9988 19.0137L16.41 15.4249M12.8736 16.8383C12.2665 16.9534 11.6399 17.0137 10.9992 17.0137C6.52159 17.0137 2.73128 14.0708 1.45703 10.0136C1.80393 8.90917 2.33729 7.88728 3.02021 6.98485M8.87746 7.89235C9.42035 7.34946 10.1704 7.01367 10.9988 7.01367C12.6556 7.01367 13.9988 8.35682 13.9988 10.0137C13.9988 10.8421 13.663 11.5921 13.1201 12.135M8.87746 7.89235L13.1201 12.135M8.87746 7.89235L5.58794 4.60283M13.1201 12.135L5.58794 4.60283M13.1201 12.135L16.41 15.4249M5.58794 4.60283C7.14776 3.59721 9.00534 3.01367 10.9992 3.01367C15.4769 3.01367 19.2672 5.95659 20.5414 10.0137C19.8345 12.2644 18.3533 14.1722 16.41 15.4249"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                        )}
                    </div>
                </div>
                {formSubmitted && IsNullOrEmpty(oldPassword) && (
                    <p className="text-red-700 font-light py-[4px] pb-[8px] pl-[4px]">
                        Please enter valid password
                    </p>
                )}
                <div className="py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm mb-[7px] relative">
                    <div className="flex flex-col">
                        <label
                            htmlFor="newPassword"
                            className="text-black-50 capitalize mb-px"
                        >
                            New password
                        </label>
                        <input
                            type={nVisible ? "text" : "password"}
                            className="text-black-60 outline-none"
                            id="newPassword"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                    </div>
                    <div
                        onClick={() => setNVisible(!nVisible)}
                        className="absolute top-2/4 -translate-y-2/4 right-2.5 cursor-pointer"
                    >
                        {nVisible ? (
                            <span>
                                <svg
                                    width="22"
                                    height="16"
                                    className="stroke-current text-black-50"
                                    viewBox="0 0 22 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M13.9988 8.01367C13.9988 9.67053 12.6556 11.0137 10.9988 11.0137C9.34193 11.0137 7.99878 9.67053 7.99878 8.01367C7.99878 6.35682 9.34193 5.01367 10.9988 5.01367C12.6556 5.01367 13.9988 6.35682 13.9988 8.01367Z"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M1.45703 8.01364C2.73131 3.95655 6.52159 1.01367 10.9992 1.01367C15.4769 1.01367 19.2672 3.95659 20.5414 8.01371C19.2672 12.0708 15.4769 15.0137 10.9992 15.0137C6.52159 15.0137 2.73128 12.0708 1.45703 8.01364Z"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                        ) : (
                            <span>
                                <svg
                                    width="22"
                                    height="20"
                                    className="stroke-current text-black-50"
                                    viewBox="0 0 22 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1.99878 1.01367L5.58794 4.60283M19.9988 19.0137L16.41 15.4249M12.8736 16.8383C12.2665 16.9534 11.6399 17.0137 10.9992 17.0137C6.52159 17.0137 2.73128 14.0708 1.45703 10.0136C1.80393 8.90917 2.33729 7.88728 3.02021 6.98485M8.87746 7.89235C9.42035 7.34946 10.1704 7.01367 10.9988 7.01367C12.6556 7.01367 13.9988 8.35682 13.9988 10.0137C13.9988 10.8421 13.663 11.5921 13.1201 12.135M8.87746 7.89235L13.1201 12.135M8.87746 7.89235L5.58794 4.60283M13.1201 12.135L5.58794 4.60283M13.1201 12.135L16.41 15.4249M5.58794 4.60283C7.14776 3.59721 9.00534 3.01367 10.9992 3.01367C15.4769 3.01367 19.2672 5.95659 20.5414 10.0137C19.8345 12.2644 18.3533 14.1722 16.41 15.4249"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                        )}
                    </div>
                </div>
                {formSubmitted && IsNullOrEmpty(newPassword) && (
                    <p className="text-red-700 font-light py-[4px] pb-[8px] pl-[4px]">
                        Please enter valid password
                    </p>
                )}
                <div className="py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm mb-[7px] relative">
                    <div className="flex flex-col">
                        <label
                            htmlFor="confirmNewPassword"
                            className="text-black-50 capitalize mb-px"
                        >
                            Confirm new password
                        </label>
                        <input
                            type={cVisible ? "text" : "password"}
                            className="text-black-60 outline-none"
                            id="confirmNewPassword"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>
                    <div
                        onClick={() => setCVisible(!cVisible)}
                        className="absolute top-2/4 -translate-y-2/4 right-2.5 cursor-pointer"
                    >
                        {cVisible ? (
                            <span>
                                <svg
                                    width="22"
                                    height="16"
                                    className="stroke-current text-black-50"
                                    viewBox="0 0 22 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M13.9988 8.01367C13.9988 9.67053 12.6556 11.0137 10.9988 11.0137C9.34193 11.0137 7.99878 9.67053 7.99878 8.01367C7.99878 6.35682 9.34193 5.01367 10.9988 5.01367C12.6556 5.01367 13.9988 6.35682 13.9988 8.01367Z"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M1.45703 8.01364C2.73131 3.95655 6.52159 1.01367 10.9992 1.01367C15.4769 1.01367 19.2672 3.95659 20.5414 8.01371C19.2672 12.0708 15.4769 15.0137 10.9992 15.0137C6.52159 15.0137 2.73128 12.0708 1.45703 8.01364Z"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                        ) : (
                            <span>
                                <svg
                                    width="22"
                                    height="20"
                                    className="stroke-current text-black-50"
                                    viewBox="0 0 22 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1.99878 1.01367L5.58794 4.60283M19.9988 19.0137L16.41 15.4249M12.8736 16.8383C12.2665 16.9534 11.6399 17.0137 10.9992 17.0137C6.52159 17.0137 2.73128 14.0708 1.45703 10.0136C1.80393 8.90917 2.33729 7.88728 3.02021 6.98485M8.87746 7.89235C9.42035 7.34946 10.1704 7.01367 10.9988 7.01367C12.6556 7.01367 13.9988 8.35682 13.9988 10.0137C13.9988 10.8421 13.663 11.5921 13.1201 12.135M8.87746 7.89235L13.1201 12.135M8.87746 7.89235L5.58794 4.60283M13.1201 12.135L5.58794 4.60283M13.1201 12.135L16.41 15.4249M5.58794 4.60283C7.14776 3.59721 9.00534 3.01367 10.9992 3.01367C15.4769 3.01367 19.2672 5.95659 20.5414 10.0137C19.8345 12.2644 18.3533 14.1722 16.41 15.4249"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                        )}
                    </div>
                </div>
                {formSubmitted && IsNullOrEmpty(confirmPassword) && (
                    <p className="text-red-700 font-light py-[4px] pb-[8px] pl-[4px]">
                        Please enter valid password
                    </p>
                )}

                {formSubmitted &&
                    !IsNullOrEmpty(confirmPassword) &&
                    confirmPassword !== newPassword && (
                        <p className="text-red-700 font-light py-[4px] pb-[8px] pl-[4px]">
                            New password should be same as confirm password
                        </p>
                    )}
                <div className="">
                    <p className="text-black-60 text-sm mb-[10px]">
                        Password should be min. 8 character length
                    </p>
                    <p className="text-red-500 text-sm mb-[30px]">
                        If you are signup with google/tiktok and changing the
                        password for very first time. Please use old password as
                        "Default"
                    </p>
                    <div className="flex items-center gap-x-2">
                        <button
                            onClick={() => handleSave()}
                            className="py-2.5 w-full text-sm rounded-lg border border-orange-color bg-orange-color font-bold text-white capitalize"
                        >
                            save
                        </button>
                        <button
                            onClick={() => {
                                setOldPassword("");
                                setNewPassword("");
                                setConfirmPassword("");
                                setFormSubmitted(false);
                            }}
                            className="py-2.5 w-full text-sm rounded-lg border border-black-10 bg-white font-medium text-black-50 capitalize"
                        >
                            cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Password;
